import { useHead } from '@unhead/react'

interface SeoProps {
  title: string
  description: string
}

function Seo({ title, description }: SeoProps) {
  const fullTitle = title.includes('HFCursos') ? title : `${title} · HFCursos`

  useHead({
    title: fullTitle,
    htmlAttrs: { lang: 'es' },
    meta: [
      { name: 'description', content: description },
      { name: 'theme-color', content: '#F4EFE6' },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
  })

  return null
}

export default Seo
